export const LeveLabel = {
    0: '--',
    1: 'Referrals.level.Referrer',
    2: 'Referrals.level.Ambassador',
    3: 'Referrals.level.Super Ambassador',
}
